<template>
	<div id="navigation">
		<nav flex="cross:center main:center" class="navbar pcShow" v-bind:class="{'begin':page==0,'first':page==1,'others':page==2,'style1':style==1,'style2':style==2,'style3':style==3,'style4':style==3&&activeIndex==3}">
			<div flex="dir:left" class="container">
				<div class="logo" @click="topIndex()" flex-box="1"></div>
				<div class="navbar_right">
					<ul flex="dir:left" class="navbar_bar">
						<li flex="cross:center main:center" v-for="navbar in navbars" v-on:mouseover="showChild($index)" v-bind:class="{active:activeIndex == $index}"
							v-on:mouseleave="hideChild($index)"><a v-link="navbar.value" v-bind:class="{isShow:navbar.key}">{{navbar.name}}</a>
							<div flex="cross:center main:center" class="sub-main" v-show="navbar.key">
								<div class="container">
									<ul flex="dir:left main:right" class="navbar_bar">
										<li flex="cross:center" v-bind:class="{glow:item.bar}" v-for="item in navbar.list" @click="thisWay($index)" >
											<a v-link="item.value">{{item.name}}
                      						</a>
											<span v-show="item.bar == true" class="barline"></span>
										</li>
									</ul>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</nav>
		<!-- <a v-link="{path:'/index'}">Index</a><br />
    <a v-link="{path:'/page'}">Page</a> -->

		<!-- phone -->
		<nav flex="cross:center main:left" class="navbar phoneShow">
			<div class="menu" v-bind:class="{change:leftmenu}" v-on:click="showLeft"></div>
		</nav>
		<div class="menuLeft phoneShow" v-bind:class="{hidden:!leftmenu}">
			<h1>
				<a v-link="'index'">首页</a>
				<span class="closeBtn" v-on:click="hideLeft"></span>
			</h1>
			<ul class="submenu">
				<li v-for="navbar in navbars" v-show="$index != 0">
					<h2 class="menuTitle" @click="changeMenuIndex($index)">{{navbar.name}}
						<span v-bind:class="{'showUp':menuActiveIndex != $index, 'showDown':menuActiveIndex == $index}"></span>
					</h2>
					<ul v-bind:class="{active:menuActiveIndex == $index}">
						<li flex="cross:center" v-for="item in navbar.list" @click="thisWay($index)">
							<a v-link="item.value">{{item.name}}</a>
						</li>
					</ul>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
import bus from './bus.js'
export default {
  props:['aidx','astyle'],
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
      navbars:[
        {"name":'首页',"value":"/index","key":false,"list":null
        },
        {"name":'咨询',"value":"/consult","key":false,"list":[
          {"name":"所有咨询","value":"/consult","bar":true},
          // {"name":"当前问题","value":"","bar":false},
          {"name":"用户体验咨询","value":"/consult/cstm_exp","bar":false},
          {"name":"品牌数字化战略咨询","value":"/consult/digitalise","bar":false},
          {"name":"转型咨询","value":"/consult/transform","bar":false},
          {"name":"对外","value":"/consult/outside","bar":false},
          {"name":"对内","value":"/consult/inside","bar":false},
          {"name":"管理层","value":"/consult","bar":false}
        ]},
        {"name":'案例',"value":"/case","key":false,"list":[
          {"name":"所有案例","value":"/case","bar":true},
          {"name":"房地产","value":"/case/detail1","bar":false},
          {"name":"高科技","value":"/case/detail2","bar":false},
          {"name":"时尚","value":"/case/detail3","bar":false},
          {"name":"政府","value":"/case/detail4","bar":false},
          {"name":"非盈利组织","value":"/case/detail5","bar":false},
          {"name":"艺术家","value":"/case/detail6","bar":false}
        ]},
        {"name":'解决方案',"value":"/solution","key":false,"list":[
          {"name":"所有方案","value":"/solution","bar":true},
          {"name":"iPad高端品牌体验中心","value":"/solution/exp","bar":false},
          {"name":"高端房地产","value":"/solution/house","bar":false},
          {"name":"影像","value":"/solution/ocean_calendar","bar":false}
        ]},
        {"name":'博客',"value":"#","key":false,"list":null},
        {"name":'公司',"value":"/company","key":false,"list":[
          {"name":"公司所有","value":"/company","bar":true},
          {"name":"愿景使命价值观","value":"/company/hope","bar":false},
          // {"name":"文化","value":"#","bar":false},
          {"name":"团队","value":"/company","bar":false},
          {"name":"特质","value":"/company/speciality","bar":false},
          {"name":"招募","value":"/company/join","bar":false}
        ]},
        {"name":'合作',"value":"#","key":false,"list":[
          {"name":"共创未来","value":"#","bar":false},
          {"name":"战略合作伙伴","value":"#","bar":false},
          {"name":"行业伙伴","value":"#","bar":false},
          {"name":"资源伙伴","value":"#","bar":false},
          {"name":"区域伙伴","value":"#","bar":false}
        ]},
      ],
      leftmenu:false,
      activeIndex:this.aidx,
      menuActiveIndex:this.aidx,
      style:this.astyle, //确定显示风格
      msg: 'Hello Vue!',
      page:0
    }
  },
  ready:function() {
    var activeIndex = "";
    console.log("the style:"+this.style);
    if(this.style == 1) {
      this.page = -1;
      return;
    }
    if(this.style == 2) {
      this.page = -1;
      return;
    }
    var obj = this;
    var windowWidth;
    $(window).scroll(function() {
    	bus.scroll = $(window).scrollTop();
    	// console.log("haha");
    	windowWidth = window.innerWidth;
		if(windowWidth >= 1060) {
		// console.log("PC");
		if($(window).scrollTop() == 0) {
		//版本1
		obj.page = 0;
		} else if($(window).scrollTop() <= 662.5) {
		//版本2
		obj.page = 1;
		} else {
		//版本3
		obj.page = 2;
		}
		} else if(windowWidth >= 800) {
		// console.log("Pad");
		if($(window).scrollTop() == 0) {
		//版本1
		obj.page = 0;
		} else if($(window).scrollTop() <= 480) {
		//版本2
		obj.page = 1;
		} else {
		//版本3
		obj.page = 2;
		}
		}
		//var index = document.getElementById("index");
		//console.log(document.getElementById("app").$route.auth.page);
		// $route.auth.page = 8;
    });

    $(window).resize(function() {
    	bus.resize = window.innerWidth;
    });
  },
  watch:{
    change:function(val, oldVal) {
      console.log(val+" and "+oldVal);
    }
  },
  methods:{
  	topIndex:function() {
  		this.$router.go("/index");
  	},
    showChild(index) {
      this.navbars[index].key = true;
    },
    hideChild(index) {
      this.navbars[index].key = false;
    },
    showLeft() {
      this.leftmenu = true;
      this.$dispatch('showLeft',true);
    },
    hideLeft() {
      this.leftmenu = false;
      this.$dispatch('showLeft',false);
    },
    thisWay(index) {
    	// 如果不用a标签，启用这个方法
    	// this.menuActiveIndex = index;
    },
    changeMenuIndex(index) {
      this.menuActiveIndex = index;
    }
  }
}
</script>
<style lang="sass" scoped>
	/* global */
	
	a {
		text-decoration: none;
	}
	/* global */
	


	$fontSize: 12px;
	$navbarHeight:63px;

	
	.navbar .logo,
	.navbar .menu {
		height: $navbarHeight;
	}
	
	.navbar .logo img,
	.navbar .menu img {
		height: 53px;
		margin-top: 5px;
		padding-left: 50px;
	}
	
	@mixin global($percent:1060/1920) {
		.navbar {
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			z-index: 10;
			.container {
				width: 1920px*$percent;
			}
			.sub-main {
				position: absolute;
				top: 63px;
				left: 0;
				right: 0;
				background-color: rgba(255, 255, 255, 0.95);
				z-index: 10;
				.barline {
					display: inline-block;
					margin-left: 5px;
					width: 2px;
					height: 18px;
					background-color: #3a97f7;
				}
				.navbar_bar { 
					li {
						padding:0 16px;
					}
				}
			}
		}
    .logo {
			background: url(../static/images/logo.png) no-repeat 50px center;
			background-size: 152.34px 53px;
			cursor: pointer;
		}
		.navbar_bar {
      list-style-type: none;
      font-size: 2rem;
      padding-right: 50px;
      li {
        padding: 0 19px;
        font-size: 16px;
        height: 63px;
        color: #3a97f7;
        &.glow {
          font-weight: 700;
        }
        &.active a {
          color: #3a97f7;
        }
        a {
          padding-top: 10px;
          font-size: 18px;
          text-decoration: none;
          color: white;
          &:hover {
            color: #3a97f7;
          }
        }
      }
			.navbar_bar {
				.allPage {
					font-weight: 700;
				}
				a {
					display: inline-block;
					/*font-weight:700;*/
					padding: 0 19px;
					font-size: 16px;
					height: 63px;
					line-height: 63px;
					color: #3a97f7;
				}
			}
		}
		.first {
			background-image: -webkit-linear-gradient(top, rgba(0, 0, 0, .5) 0, rgba(0, 0, 0, .0) 100%, transparent 100%);
			background-image: -moz-linear-gradient(top, rgba(0, 0, 0, .5) 0, rgba(0, 0, 0, .0) 100%, transparent 100%);
			background-image: linear-gradient(top, rgba(0, 0, 0, .5) 0, rgba(0, 0, 0, .0) 100%, transparent 100%);
		}
		.others {
			background-color: rgba(255, 255, 255, .95);
			.logo {
				background: url(../static/images/logo_2.png) no-repeat 50px center;
				background-size: 152.34px 53px;
			}
			li {
				&.active a {
					color: #4a4a4a;
				}
				a {
					color: #3a97f7;
					&:hover {
						color: #4a4a4a;
					}
				}
			}
			.navbar_bar {
				.navbar_bar {
					.allPage {
						font-weight: 700;
					}
					a {
						display: inline-block;
						/*font-weight:700;*/
						padding: 0 19px;
						font-size: 16px;
						height: 63px;
						line-height: 63px;
						color: white;
					}
				}
			}
			.sub-main {
				background-color: rgba(58, 151, 247, 0.95);
				.navbar_bar {
					li {
						color: white;
					}
				}
				.barline {
					display: inline-block;
					margin-left: 5px;
					width: 2px;
					height: 18px;
					background-color: white;
				}
			}
		}
	    .style1 {
	      background-color: #bcd9ff;
				.navbar_bar {
					.navbar_bar {
						.allPage {
							font-weight: 700;
						}
						a {
							display: inline-block;
							/*font-weight:700;*/
							padding: 0 19px;
							font-size: 16px;
							height: 63px;
							line-height: 63px;
							color: white;
						}
					}
				}
				.sub-main {
					background-color: rgba(58, 151, 247, 0.95);
					.navbar_bar {
						li {
							color: white;
						}
					}
					.barline {
						display: inline-block;
						margin-left: 5px;
						width: 2px;
						height: 18px;
						background-color: white;
					}
				}
	    }
	    .style2 {
			.navbar_bar li.active > a {
    			color:#3AF7B2;
	    	}
		}
		.style3 {
			background-image: -webkit-linear-gradient(top, rgba(0, 0, 0, .5) 0, rgba(0, 0, 0, .0) 100%, transparent 100%);
			background-image: -moz-linear-gradient(top, rgba(0, 0, 0, .5) 0, rgba(0, 0, 0, .0) 100%, transparent 100%);
			background-image: linear-gradient(top, rgba(0, 0, 0, .5) 0, rgba(0, 0, 0, .0) 100%, transparent 100%);
		}
		.style4 {
			background-image: none;
			&.first, &.others {
				background-image:none;
				background-color: rgba(255, 255, 255, .95);
				.logo {
					background: url(../static/images/logo_2.png) no-repeat 50px center;
					background-size: 152.34px 53px;
				}
				li {
					&.active a {
						color: #4a4a4a;
					}
					a {
						color: #3a97f7;
						&:hover {
							color: #4a4a4a;
						}
					}
				}
				.navbar_bar {
					.navbar_bar {
						.allPage {
							font-weight: 700;
						}
						a {
							display: inline-block;
							/*font-weight:700;*/
							padding: 0 19px;
							font-size: 16px;
							height: 63px;
							line-height: 63px;
							color: white;
						}
					}
				}
				.sub-main {
					background-color: rgba(58, 151, 247, 0.95);
					.navbar_bar {
						li {
							color: white;
						}
					}
					.barline {
						display: inline-block;
						margin-left: 5px;
						width: 2px;
						height: 18px;
						background-color: white;
					}
				}
			}	
		}
	}
	
	@include global()
	/* 二级菜单 */
	
	.navbar[flex] {
		overflow: visible;
	}
	
	.hidden {
		display: none;
	}
	
	.isShow {
		color: green;
	}
	
	
	


  @media screen and (min-width:1080px) {
    .phoneShow {
      display:none;
    }
  }

	/* pad */
	 
	@media screen and (max-width:1079px) and (min-width: 800px) {
    .phoneShow {
      display:none;
    }
		@include global(800/1920)
    .menuLeft {
			display: none;
		}
    .navbar .sub-main {
      top:46px;
    }
		$fontSize: 12px;
		$navbarHeight:46px;
		.navbar {
			&.others {
				background-color: rgba(255, 255, 255, .95);
				.logo {
					background: url(../static/images/logo_2.png) no-repeat 50px center;
					background-size: 115px 40px;
				}
				.navbar_bar {
					.navbar_bar {
						.allPage {
							font-weight: 700;
						}
						a {
							display: inline-block;
							/*font-weight:700;*/
							padding: 0 19*0.8+px;
							font-size: 16*0.8+px;
							height: 63*0.8+px;
							line-height: 63*0.8+px;
						}
					}
				}
			}
			.logo {
				background: url(../static/images/logo.png) no-repeat 50px center;
				background-size: 115px 40px;
			}
			.menu img {
				height: 40px;
				margin-top: 3px;
				padding-left: 36px;
			}
			.navbar_bar {
				list-style-type: none;
				font-size: 2rem;
				padding-right: 36px;
				li {
					padding: 0 11px;
					font-size: 14px;
					height: $navbarHeight;
					a {
						padding-top: 10px;
						font-size: 16px;
						text-decoration: none;
					}
				}
				.navbar_bar {
					.allPage {
						font-weight: 700;
					}
					li {
						padding: 0 9px;
					}
					a {
						display: inline-block;
						/*font-weight:700;*/
						padding: 0 19*0.8+px;
						font-size: 16*0.8+px;
						height: 63*0.8+px;
						line-height: 63*0.8+px;
					}
				}
			}
		}
		.navbar .logo,
		.navbar .menu {
			height: $navbarHeight;
		}
	}
	/* phone */
	
	@media screen and (max-width:799px) {
		.pcShow {
      display:none;
    }
    .navbar {
      padding: 0;
      height: 50px;
      background: rgba(255, 255, 255, .7) url(../static/images/phone/logo.png) no-repeat center center;
      background-size: 100px auto;
      .menu {
        height: 100%;
        width: 60px;
        background: url(../static/images/phone/List.png) no-repeat center center;
        background-size: 23px auto;
        &.change {
          position: relative;
          background: none;
        }
      }
    }
    .menuLeft {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      background-color: #f3f3f3;
      width: 93%;
      z-index: 99;
      h1 {
        position: relative;
        padding: 0 20px;
        background-color: #f3f3f3;
        height: 66px;
        margin: 0;
        line-height: 66px;
        &:after {
          position: absolute;
          bottom: 0;
          left: 20px;
          right: 20px;
          content: ' ';
          height: 1px;
          background-color: #c3c3c3;
        }
        a {
          /*color:;*/
          font-size: 18px;
          color: #2d2d2d;
        }
        span {
          position: absolute;
          top: 17px;
          right: 11px;
          width: 32px;
          height: 32px;
          background: url("../static/images/phone/close.png") no-repeat center center;
          background-size: 14px 14px;
          display: inline-block;
        }
      }
      .submenu {
        position: absolute;
        top: 66px;
        bottom: 0;
        left: 0;
        right: 0;
        padding-bottom: 60px;
        overflow: scroll;
        h2 {
          position: relative;
          font-size: 16px;
          padding: 0 20px;
          background-color: #f3f3f3;
          height: 64px;
          margin: 0;
          line-height: 64px;
          span {
            position: absolute;
            top: 25px;
            right: 20px;
            width: 14px;
            height: 14px;
            display: inline-block;
            &.showDown {
              background: url("../static/images/phone/down.png") no-repeat right center;
              background-size: 14px 8px;
            }
            &.showUp {
              background: url("../static/images/phone/back.png") no-repeat right center;
              background-size: 8px 14px;
            }
          }
        }
        ul {
          background-color: white;
          display: none;
          padding: 10px 0;
          margin: 0;
          width: auto;
          height: 100%;
          &.active {
            display: block;
          }
          li {
            margin: 0;
            a {
              width: 100%;
              font-size: 13px;
              line-height: 13px;
              color: rgb(147, 147, 147);
              letter-spacing: 1px;
              display: block;
              padding: 10px 20px;
            }
          }
        }
      }
    }
	}
</style>


// WEBPACK FOOTER //
// Navigation.vue?65be0058